import ReachEstimate from '../ReachEstimate'

type HeaderPillProps = {
  segment: object
  canShowCount: boolean
  loadEstimate: boolean
}

const HeaderPill = ({ segment, canShowCount, loadEstimate }: HeaderPillProps) => {
  // Show ReachEstimate for all segments when count can be shown (including My Matches)
  if (canShowCount) {
    return (
      <ReachEstimate
        loadEstimate={loadEstimate}
        segment={segment}
      />
    )
  }

  return null
}

export default HeaderPill
